import { MemberstackStatus } from './enums/memberstackStatus';
export interface MemberstackMessage {
  event: MemberstackStatus;
  payload: any;
  reason?: string[];
  timestamp: number;
}

export interface MemberCreatedPayload {
  auth?: {
    email: string;
  };
  customFields?: {
    [key: string]: string;
  };
  metaData?: {
    [key: string]: string;
  };
  planConnections?: {
    planConnectionId?: string;
    planId?: string;
    status?: string;
  }[];
  id?: string;
  stripeCustomerId?: string;
  verified?: boolean;
}

export interface MemberUpdatedPayload {
  auth?: {
    email: string;
  };
  customFields?: {
    [key: string]: string;
  };
  metaData?: {
    [key: string]: string;
  };
  id?: string;
  stripeCustomerId?: string;
  verified?: boolean;
}

export interface MemberPlanAddedPayload {
  member?: {
    id?: string;
    email: string;
    stripeCustomerId?: string;
    verified?: boolean;
    customFields?: {
      [key: string]: string;
    };
    metaData?: {
      [key: string]: string;
    };
  };
  planConnection?: {
    payment?: {
      cancelAtDate: string;
      cancelAtPeriodEnd: boolean;
      stripeSubscriptionId: string;
    };
    planId: string;
    priceId: string;
    status: string;
  };
}

export interface MemberPlanCanceledPayload {
  member?: {
    id?: string;
    email: string;
    stripeCustomerId?: string;
    verified?: boolean;
    customFields?: {
      [key: string]: string;
    };
    metaData?: {
      [key: string]: string;
    };
  };
  planConnection?: {
    id: string;
    planId: string;
  };
}

export interface MemberPlanUpdatedPayload {
  member?: {
    id?: string;
    email: string;
    stripeCustomerId?: string;
    verified?: boolean;
    customFields?: {
      [key: string]: string;
    };
    metaData?: {
      [key: string]: string;
    };
  };
  planConnection?: {
    payment?: {
      cancelAtDate: string;
      cancelAtPeriodEnd: boolean;
      stripeSubscriptionId: string;
    };
    planId: string;
    priceId: string;
    status: string;
  };
  prevPlanConnection?: {
    payment?: {
      cancelAtDate: string;
      cancelAtPeriodEnd: boolean;
      stripeSubscriptionId: string;
    };
    planId: string;
    priceId: string;
    status: string;
  };
}
